import React from 'react';

import { Card } from 'DesignSystem/ui/card';
import { cn } from 'DesignSystem/utils';

type EventOverviewCardProps = {
  icon: React.ReactNode;
  title: string;
  actions?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

export function EventOverviewCard({ icon, title, actions, footer, children, className }: EventOverviewCardProps) {
  return (
    <Card className={cn('overflow-hidden border-zinc-200 bg-white', className)}>
      <div className="flex items-center justify-between gap-3 border-b border-zinc-200 bg-indigo-50 px-4 py-2.5">
        <div className="flex items-center gap-2 text-sm font-medium text-zinc-800">
          {icon}
          <h2 className="text-sm font-medium">{title}</h2>
        </div>
        {actions}
      </div>
      <div className="px-4 py-4">{children}</div>
      {footer}
    </Card>
  );
}
